// extracted by mini-css-extract-plugin
module.exports = {"item":"item--1baLB","imageWrap":"imageWrap--2GvyJ","mask":"mask--31bic","title":"title--Zkue2","describe":"describe--3X1Z_"};